import type { FC } from "react";
import { LogoLoadingSpinner } from "@/components/logo-loading-spinner/LogoLoadingSpinner";
import styles from "./PlayerLoader.module.scss";
export const PlayerLoader: FC = () => (
  <div className={styles.playerLoaderWrapper}>
    <LogoLoadingSpinner />
  </div>
);
